import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./slices/userSlice";
import categoryReducer from "./slices/categorySlice";
import appReducer from "./slices/appSlice";
import eventReducer from "./slices/orgAdmin/eventSlice";
import teamReducer from "./slices/orgAdmin/teamSlice";
import newsReducer from "./slices/orgAdmin/newsSlice";
import categoryOrgReducer from "./slices/orgAdmin/categoriesOrgSlice";
import subscribersReducer from "./slices/orgAdmin/subscribersSlice";
import weddingsReducer from "./slices/orgAdmin/weddingsSlice";
import companiesReducer from "./slices/superAdmin/companiesSlice";
import languagesReducer from "./slices/superAdmin/languagesSlice";
import seoReducer from "./slices/orgAdmin/seoSlice";
import promotionsReducer from "./slices/orgAdmin/promotionsSlice";
import podcastsReducer from "./slices/orgAdmin/podcastsSlice";
import usersReducer from "./slices/orgAdmin/usersSlice";
import lawsReducer from "./slices/orgAdmin/lawsSlice";
import tagsReducer from "./slices/orgAdmin/tagsOrgSlice";
import slideshowReducer from "./slices/orgAdmin/slideshowSlice";

const userPersistConfig = {
  key: "user",
  storage,
};

const userPersistedReducer = persistReducer(userPersistConfig, userReducer);

const store = configureStore({
  reducer: {
    user: userPersistedReducer,
    categories: categoryReducer,
    app: appReducer,
    events: eventReducer,
    team: teamReducer,
    news: newsReducer,
    categoriesOrg: categoryOrgReducer,
    subscribers: subscribersReducer,
    weddings: weddingsReducer,
    companies: companiesReducer,
    languages: languagesReducer,
    seo: seoReducer,
    promotions: promotionsReducer,
    podcasts: podcastsReducer,
    users: usersReducer,
    laws: lawsReducer,
    tags: tagsReducer,
    slideshow: slideshowReducer,
  },
});

export const persistor = persistStore(store);

export default store;
